// Generated by ts-to-zod
import { z } from 'zod';

export const duplicateHookPayloadSchema = z.object({
  name: z.string(),
  copyDependencies: z.boolean().optional(),
  copySecrets: z.boolean().optional(),
  copyQueues: z.boolean().optional(),
});
